/**
 * The guardrails formatter — an orchestrator route, not a platform-api one, so
 * it takes the shared apiClient with the orchestrator base (same Entra token,
 * different origin). It's a real LLM call: expect 30–90s, and give it a loading
 * state rather than a spinner-less wait.
 */
import { apiRequest } from '../../lib/apiClient.js';
import { agentBaseUrl } from '../../lib/agentApi.js';
import type { PolicyFormatRequest, PolicyFormatResponse } from '../../lib/types.js';

export const formatPolicyDocument = (req: PolicyFormatRequest): Promise<PolicyFormatResponse> =>
  apiRequest<PolicyFormatResponse>('/api/agent/policy-format', {
    method: 'POST',
    body: req,
    baseUrl: agentBaseUrl,
  });
